import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

(function () {
    "use strict";

    function initSection(sectionEl) {
        if (!sectionEl) return;
        if (sectionEl.getAttribute("data-enable-phone-parallax") !== "1") return;

        const phone1 = sectionEl.querySelector(".js-phone-1");
        const phone2 = sectionEl.querySelector(".js-phone-2");
        if (!phone1 || !phone2) return;

        const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (reduceMotion) return;

        const isDesktop = window.matchMedia("(min-width: 768px)").matches;
        if (!isDesktop) return;

        // Kill previous if re-init happens
        if (sectionEl._phonesST) {
            sectionEl._phonesST.kill(true);
            sectionEl._phonesST = null;
        }

        // Use a timeline controlled by ScrollTrigger (smooth)
        const tl = gsap.timeline({
            defaults: { ease: "none" },
            scrollTrigger: {
                trigger: sectionEl,
                start: "top bottom",
                end: "bottom top",
                scrub: 0.8,
                invalidateOnRefresh: true,
                fastScrollEnd: true,
            },
        });

        // Move distances (tune)
        tl.to(phone1, { y: -105, force3D: true }, 0);
        tl.to(phone2, { y:  105, force3D: true }, 0);

        sectionEl._phonesST = tl.scrollTrigger;
    }

    function killAll() {
        document.querySelectorAll(".section-success-app-banner").forEach((el) => {
            if (el._phonesST) {
                el._phonesST.kill(true);
                el._phonesST = null;
            }
            gsap.set(el.querySelectorAll(".js-phone-1, .js-phone-2"), { clearProps: "transform" });
        });
    }

    function initAll() {
        document.querySelectorAll(".section-success-app-banner").forEach(initSection);
        ScrollTrigger.refresh();
    }

    let t = null;
    function onResize() {
        clearTimeout(t);
        t = setTimeout(() => {
            killAll();
            initAll();
        }, 150);
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => {
            initAll();
            window.addEventListener("resize", onResize);
            window.addEventListener("orientationchange", onResize);
        });
    } else {
        initAll();
        window.addEventListener("resize", onResize);
        window.addEventListener("orientationchange", onResize);
    }
})();